import { useEffect, useState } from 'react';

export const useIsFetchingAssets = () => {
	const [isFetchingAssets, setIsFetchingAssets] = useState(false);

	useEffect(() => {
		const eventHandler = () => setIsFetchingAssets(true);
		document.addEventListener('assetOverview_fetching_assets_start', eventHandler);

		return () => {
			document.removeEventListener('assetOverview_fetching_assets_start', eventHandler);
		};
	}, []);

	useEffect(() => {
		const eventHandler = () => setIsFetchingAssets(false);
		document.addEventListener('assetOverview_fetching_assets_stop', eventHandler);

		return () => {
			document.removeEventListener('assetOverview_fetching_assets_stop', eventHandler);
		};
	}, []);

	return { isFetchingAssets };
};
